/**
 * Triggers jQuery event when all CSS files are loaded. Sometimes it is necessary with asynchronous CSS
 */
jQuery(document).ready(function ($) {
    var counter = 0;
    
    setTimeout(checkCss, 0);
    
    function checkCss() {
        let allCss = $('link[rel=stylesheet][onload]').length;
        
        if (window.cssCount === allCss || counter > 9) {
            $(document).trigger('afterCssLoad');
            return;
        }
        
        counter++;
        
        setTimeout(checkCss, 0);
    }
});